export default __webpack_public_path__ + "static/media/funnel_ar 1.e23dfd8b.png";